import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";

class ErrorBoundaryBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Uncaught render error:", error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 2,
            p: 4,
            textAlign: "center",
          }}
        >
          <Typography variant="h5">Something went wrong.</Typography>
          <Typography variant="body2" color="text.secondary">
            An unexpected error occurred while rendering this page.
          </Typography>
          <Stack direction="row" spacing={1.5}>
            <Button variant="outlined" onClick={this.props.onGoHome}>
              Go to dashboard
            </Button>
            <Button variant="contained" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </Stack>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default function ErrorBoundary({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <ErrorBoundaryBase resetKey={location.key} onGoHome={() => navigate("/")}>
      {children}
    </ErrorBoundaryBase>
  );
}
